import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  height: 37px;
`;

export const ContentBox = styled.div`
  width: 35%;
  background-color: #eeeeee;
`;

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 5%;
`;
